import React from 'react';

const InsightCard = ({ title, text }) => {
  if (!title && !text) return null;

  return (
    <div
      className="t-mt-3.5 t-p-3.5 t-px-4 t-rounded-xl t-border t-border-quiz-teal/25 t-animate-[fadeUp_.3s]"
      style={{ background: 'linear-gradient(135deg, rgba(17,109,110,.07), rgba(246,225,71,.12))' }}
    >
      <h4 className="t-font-serif t-text-[15px] t-italic t-text-quiz-teal t-mb-1 t-m-0">{title}</h4>
      <p className="t-text-[12.5px] t-leading-relaxed t-m-0">{text}</p>
    </div>
  );
};

export default InsightCard;
